import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";

const AllNiosPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [allNiosPricing, setAllNiosPricing] = useState([]);
  const [niosClass, setNiosClass] = useState([]);
  const [niosClassId, setNiosClassId] = useState();
  const [niosSubject, setNiosSubject] = useState([]);
  const [niosSubjectId, setNiosSubjectId] = useState();

  // Fetch the class names
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        const { data } = resp;
        // console.log(resp.data);
        // console.log(data);
        setNiosClass(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (niosClassId) {
      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${niosClassId}`)
        .then((result) => {
          const { data } = result;
          setNiosSubject(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [niosClassId]);

  const fetchData = () => {
    axios
      .get(
        `${API_BASE_URL}/pricing/exam-notes?niosSubjectId=${niosSubjectId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((result) => {
        console.log(result?.data?.data);
        const data = result?.data?.data;
        setAllNiosPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleAddNiosPricing = () => {
    navigate("/exam-notes-pricing/add-nios-pricing");
  };
  const handleViewAllNiosPricing = () => {
    navigate("/exam-notes-pricing/all-nios-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/pricing/exam-notes/${id}`);
  };
  const handleDelete = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this note price?"
    );
    if (confirmed) {
      axios
        .delete(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => {
          console.log(result);
          alert("Notes price Deleted Successfully.");
          fetchData();
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting notes price.");
        });
    }
  };
  return (
    <div id="allschoolnotes-inner-wrapper">
      <BiArrowBack
        onClick={handleGoBack}
        className="left-arrow-icon mt-3"
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          fontSize: "25px",
          color: "#000", // Customize the color as needed
        }}
      />

      <div className="allschoolnotes-header-div">
        <h5>All Nios Notes Pricing</h5>
        <div className="allschoolnotes-header-btns">
          <button className="add-note-btn" onClick={handleAddNiosPricing}>
            + Add Nios Pricing
          </button>
          <button className="all-notes-btn" onClick={handleViewAllNiosPricing}>
            All Pricing
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="note-detail-form form-container">
        <div className="input-group">
          <div style={{ paddingBottom: "10px" }}>
            <label className="label">Class Name</label>
          </div>
          <select
            className="select-dropdown"
            value={niosClassId}
            onChange={(e) => setNiosClassId(e.target.value)}
            required
          >
            <option value="">-Select Class-</option>
            {niosClass &&
              niosClass.map((classes) => (
                <option value={classes._id} key={classes._id}>
                  {classes?.className}
                </option>
              ))}
          </select>
        </div>

        <div className="new-chapter-form-group">
          <label className="new-chapter-label">Subject Name</label>
          <select
            className="new-chapter-dropdown"
            value={niosSubjectId}
            onChange={(e) => setNiosSubjectId(e.target.value)}
            required
          >
            <option value="">-Select Subject-</option>
            {niosSubject.map((subject, idx) => (
              <option key={idx} value={subject._id}>
                {subject.subjectName}
              </option>
            ))}
          </select>
        </div>

        <div className="form1-btns">
          <button className="btn-save">Search Pricing</button>
        </div>
      </form>

      <div className="allschoolnotes-table-container">
        <h5>All Nios Notes Pricing</h5>
        <table className="allschoolnotes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Nios Class</th>
              <th>Subject</th>
              <th>Notes Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allNiosPricing.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item?.niosSubjectId?.niosClassId?.className}</td>
                <td>{item?.niosSubjectId?.subjectName}</td>
                <td>{item?.price}</td>

                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(item._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(item._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllNiosPricing;
